module.exports = __webpack_public_path__ + "static/media/promo.0c0c3dd1.png";